var product_list = [
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "E-Class (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "E-Class (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A5 Avant (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2022,
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2023,
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2024,
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2025,
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Tayron (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2024,
    "Mo": "J8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2025,
    "Mo": "J8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "QS (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "5-Series Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "5-Series Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kodiaq (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Kodiaq (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2019,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2020,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2021,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2022,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2023,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2024,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Perodua",
    "Y": 2025,
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2006,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2007,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2008,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2009,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2016,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2017,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2018,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2019,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2020,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2021,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2022,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2023,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2024,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2016,
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2017,
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2022,
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2023,
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X3 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQS SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQS SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQS SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "PV5 Passenger (5-Türer) MPV | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Wagoneer S (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2021,
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2022,
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2023,
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2024,
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2025,
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "LBX (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "LBX (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Avant e-tron (5-Türer) Kombi | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "K4 (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2014,
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2019,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2020,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2021,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2022,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2023,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2024,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2025,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2018,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2019,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2020,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2021,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2022,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2023,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2024,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Perodua",
    "Y": 2025,
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2004,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2005,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Crown Crossover (S235) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Crown Crossover (S235) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Crown Crossover (S235) (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2008,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2009,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ram",
    "Y": 2024,
    "Mo": "Rampage (4-Türer) Crew Cab | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ram",
    "Y": 2025,
    "Mo": "Rampage (4-Türer) Crew Cab | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2012,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2013,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2014,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2016,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2018,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2019,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "ë-C4 X (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "ë-C4 X (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "ë-C4 X (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2022,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2023,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2024,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2025,
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "E-3008 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "E-3008 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2005,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2006,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2007,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2008,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2009,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "EX30 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EX30 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Accord (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Accord (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Accord (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2024,
    "Mo": "3 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2025,
    "Mo": "3 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2024,
    "Mo": "4 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Polestar",
    "Y": 2025,
    "Mo": "4 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Alphard (AH40) (5-Türer) MPV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Alphard (AH40) (5-Türer) MPV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Alphard (AH40) (5-Türer) MPV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2004,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2006,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2009,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2010,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2011,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2012,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2013,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2014,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2015,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2016,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2017,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2018,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Voyah",
    "Y": 2025,
    "Mo": "Courage (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Grande Panda (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Tank 500 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Tank 500 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Tank 500 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Tacoma (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Tacoma (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Santa Fe (MX5) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Santa Fe (MX5) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Forester (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2007,
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2002,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2003,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2004,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1990,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1991,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1992,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1993,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1994,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Highlander (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Highlander (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Highlander (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2011,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1995,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1996,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1995,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1996,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1997,
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1998,
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1999,
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2000,
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2001,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2002,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1993,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1994,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1996,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1997,
    "Mo": "Sintra (5-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Sintra (5-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Sintra (5-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1980,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1981,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1982,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1983,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1984,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1985,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1986,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1987,
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1996,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1997,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2002,
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2003,
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2004,
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2005,
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2006,
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2007,
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2010,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2011,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2012,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2013,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2015,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2016,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2017,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2018,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2019,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2020,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2021,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2022,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1993,
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1994,
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1993,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1994,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Master (4-Türer) Van | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "PV5 Cargo (4-Türer) Van | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "E-Class (W214) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "E-Class (W214) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Expert (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2022,
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2023,
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2024,
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2025,
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Connect (4-Türer) Van | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Connect (4-Türer) Van | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2001,
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "RX (AL30) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "RX (AL30) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "RX (AL30) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2004,
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2006,
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV250 (4-Türer) Van | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV250 (4-Türer) Van | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV250 (4-Türer) Van | 2019-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2012,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2013,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2014,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2016,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2018,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2019,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "Como (5-Türer) Bus | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2012,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2013,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2014,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2016,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2018,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2019,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "Como (5-Türer) Van | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Zeekr",
    "Y": 2025,
    "Mo": "7GT (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-80 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-80 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2020,
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2021,
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2022,
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2023,
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2024,
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2025,
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Avant (C9) (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EX90 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2020,
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2021,
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2018,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2019,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Bolt EUV (5-Türer) SUV | 2022-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Bolt EUV (5-Türer) SUV | 2022-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2021,
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2022,
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2023,
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2024,
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2025,
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Tasman (4-Türer) Pickup | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "HS (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2024,
    "Mo": "8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2025,
    "Mo": "8 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "i5 Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "i5 Touring (G61) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2023,
    "Mo": "J7 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2024,
    "Mo": "J7 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2025,
    "Mo": "J7 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1986,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1987,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1988,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1989,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1990,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1991,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1992,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "XC70 (5-Türer) Kombi | 1998-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1999,
    "Mo": "XC70 (5-Türer) Kombi | 1998-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2019,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2020,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2021,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2022,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2023,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2024,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2025,
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2009,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2010,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2011,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2012,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2013,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2014,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Brilliance",
    "Y": 2015,
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1994,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1995,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1996,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1997,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1998,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1999,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2000,
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1997,
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1998,
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1999,
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2000,
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2001,
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2002,
    "Mo": "V40 (5-Türer) Kombi | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "V40 (5-Türer) Kombi | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "V40 (5-Türer) Kombi | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2000,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2001,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2002,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2003,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2004,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2005,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2006,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2007,
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1983,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1984,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1985,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1986,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1987,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1988,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1989,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1990,
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1996,
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1997,
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1998,
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1999,
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1989,
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1990,
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1991,
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1992,
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1993,
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1994,
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2007,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2008,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2009,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2010,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2011,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2012,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2013,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2014,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2015,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2016,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2017,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2018,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2019,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2020,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2021,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2022,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2023,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2024,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2025,
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser Prado 250 (250) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser Prado 250 (250) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2005,
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2006,
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2007,
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2008,
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2009,
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1984,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1985,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1986,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1987,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1988,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1989,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1990,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1991,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1992,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1993,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1994,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1995,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1996,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1997,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1998,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1999,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2000,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2001,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2002,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2003,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2004,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2005,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2006,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2007,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2008,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2009,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2010,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2011,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2012,
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2013,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2014,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2015,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2020,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2021,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2022,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2023,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2024,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2025,
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2007,
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1998,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1999,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2000,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2001,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2002,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2003,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "5-Series Touring (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "5-Series Touring (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "5-Series Touring (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2007,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2008,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2009,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2010,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2011,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2012,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2013,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2014,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2015,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2016,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2017,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2018,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2019,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2020,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2021,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2022,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2023,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2024,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2025,
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2002,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2003,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2004,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2005,
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 1999,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2000,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2001,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2002,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2003,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2004,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2005,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2006,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2007,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2008,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2009,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2010,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2011,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2012,
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1997,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1991,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1992,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1993,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1994,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1995,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1996,
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1997,
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1998,
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1999,
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2000,
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2003,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1998,
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero (5-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1986,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1987,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1988,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1989,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1990,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1991,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2007,
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2008,
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2009,
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2010,
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2011,
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2012,
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1990,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1991,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1992,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1993,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1995,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1992,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1993,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1994,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1995,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1996,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1997,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "V90 (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "V90 (5-Türer) Kombi | 1997-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1994,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1995,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1996,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1997,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1998,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2000,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2002,
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2006,
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2007,
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2008,
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2009,
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2010,
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1992,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1993,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1994,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1995,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1992,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1993,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1994,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1995,
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2017,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2018,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2019,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2020,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2021,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2022,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2023,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2024,
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2008,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2009,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2010,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2011,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2012,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2013,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2014,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2015,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2020,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2021,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2022,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2023,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2024,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2025,
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1985,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1986,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1987,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1988,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1989,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1990,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1991,
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1996,
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1997,
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 1999,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2000,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1985,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1986,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1987,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1988,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1989,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1990,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1991,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1992,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1993,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1994,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1995,
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1985,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1986,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1987,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1988,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1989,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1990,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1991,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1984,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1985,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1986,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1987,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1988,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1989,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1990,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1991,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1992,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1993,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1994,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1995,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1996,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1997,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1998,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1999,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2000,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2001,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2002,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2003,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2004,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2005,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2006,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2007,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2008,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2009,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2010,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2011,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2012,
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2001,
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2002,
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2003,
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2004,
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2005,
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2006,
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1994,
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1995,
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1996,
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Life (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Life (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Life (5-Türer) Kombi | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2009,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2010,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2011,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2012,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2013,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2014,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2015,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2016,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2017,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2018,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2019,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2020,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2021,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2022,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2023,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2024,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2025,
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1996,
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1997,
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1998,
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1999,
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2000,
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2001,
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2005,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2006,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2007,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2008,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2009,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2010,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2011,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2012,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2013,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2014,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2015,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2016,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2017,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2018,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2019,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2020,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2021,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2022,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2023,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2024,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2025,
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1989,
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1990,
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1991,
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1992,
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1993,
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2004,
    "Mo": "Streetwise (3-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2005,
    "Mo": "Streetwise (3-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2005,
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2006,
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2007,
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2008,
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1988,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1989,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1990,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1991,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1992,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1993,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1994,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1995,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Partner (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2016,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2017,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Shark (4-Türer) Pickup | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Shark (4-Türer) Pickup | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID. UNYX (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2020,
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2021,
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2022,
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "C-HR (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "C-HR (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Prius (XW60) (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Prius (XW60) (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Prius (XW60) (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Prologue (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Prologue (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Tasman (4-Türer) Pickup | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Kicks Play (P15) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Kicks Play (P15) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2008,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2021,
    "Mo": "09 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2022,
    "Mo": "09 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2023,
    "Mo": "09 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2024,
    "Mo": "09 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "09 (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2019,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2020,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2021,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2022,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2023,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2024,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "4 (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Leapmotor",
    "Y": 2025,
    "Mo": "C11 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Boreal (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 1995,
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1996,
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1997,
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1998,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1999,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2002,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2003,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2004,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2005,
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1993,
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1994,
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1995,
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1996,
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1997,
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 1998,
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "V70 (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "V70 (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1999,
    "Mo": "V70 (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2002,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1996,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1997,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2002,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2003,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2004,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2005,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2006,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2007,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2008,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2009,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1988,
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1989,
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1990,
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1991,
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1997,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2001,
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2002,
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan (Mk. III) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Tiguan (Mk. III) (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2002,
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1989,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1990,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1991,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1992,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1993,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1994,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1995,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1990,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1991,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1992,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1993,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1995,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1986,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1987,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1988,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1989,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1990,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1991,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1992,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1983,
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1984,
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1985,
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1986,
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Windstar (5-Türer) MPV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Windstar (5-Türer) MPV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Windstar (5-Türer) MPV | 1995-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1995,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1996,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1997,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1998,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1999,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2000,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2001,
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1996,
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1997,
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1998,
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1999,
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2000,
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1997,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1998,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1999,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2000,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2001,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2002,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AION",
    "Y": 2024,
    "Mo": "V (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AION",
    "Y": 2025,
    "Mo": "V (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2001,
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2002,
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2003,
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1996,
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1997,
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1998,
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1999,
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2000,
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2001,
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1998,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1999,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2000,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2001,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2002,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2003,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2004,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2005,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2006,
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1986,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1987,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1988,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1989,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1990,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1991,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1992,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1993,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1994,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1996,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2004,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2005,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2006,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2007,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2008,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2009,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2010,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2011,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2012,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2013,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2014,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2015,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2016,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2017,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2018,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2019,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2020,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2021,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2022,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2023,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2024,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Tata",
    "Y": 2025,
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2002,
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2003,
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2004,
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2000,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2001,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2002,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2003,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2004,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2005,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1994,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1995,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1996,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1997,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1997,
    "Mo": "Nubira (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1998,
    "Mo": "Nubira (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1999,
    "Mo": "Nubira (5-Türer) Kombi | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1998,
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1999,
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2000,
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2001,
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2005,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2006,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2007,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2008,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2008,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2009,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2010,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2011,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2012,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2013,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2014,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2015,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2016,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2017,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2018,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2019,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2020,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2021,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2022,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2023,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2024,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2025,
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1996,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1997,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1997,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2006,
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2007,
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2008,
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2009,
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2010,
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2011,
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2021,
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2022,
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1997,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1998,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1999,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2000,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2001,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2002,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2003,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2004,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2005,
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1988,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1989,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1990,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1991,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1992,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1993,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1994,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1995,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1996,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1997,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1998,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 1999,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2000,
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1989,
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1990,
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1991,
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1992,
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1993,
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1994,
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2001,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2002,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2003,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2000,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2001,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2002,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2003,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2004,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2005,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2006,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2007,
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2000,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2001,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2002,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2000,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2001,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2002,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2003,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2004,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2005,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2008,
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2009,
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2010,
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1993,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1994,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1995,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2004,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2005,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2006,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2004,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2005,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2006,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2007,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2008,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2009,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2010,
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "V40 (5-Türer) Kombi | 2000-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2001,
    "Mo": "V40 (5-Türer) Kombi | 2000-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1986,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1987,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1988,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1989,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1990,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1991,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1992,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1994,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1995,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1996,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1997,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1998,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2000,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2002,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2015,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2016,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2017,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2018,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2019,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2020,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2021,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2022,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1998,
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1995,
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1996,
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1997,
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1998,
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2000,
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2002,
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2006,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2007,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2008,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2009,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2010,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2007,
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2008,
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2009,
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1991,
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1989,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1990,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1991,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1992,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1993,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1994,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1995,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1996,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1997,
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1997,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1998,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 1999,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2000,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2001,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb (B9) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Superb (B9) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter (T7) (4-Türer) Van | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caravelle (T7) (4-Türer) Bus | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "06 EM-P (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2023,
    "Mo": "7 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2024,
    "Mo": "7 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Y": 2025,
    "Mo": "7 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Transporter (T7) (4-Türer) Van | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1996,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2004,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2005,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2006,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2007,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "1-Series (5-Türer) Schrägheck | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Impreza (GU) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Impreza (GU) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Impreza (GU) (5-Türer) Schrägheck | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2017,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2018,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2019,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2020,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2021,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2025,
    "Mo": "Navigator (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat Variant (B9) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Passat Variant (B9) (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "EX40 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "EX40 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2010,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2011,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2012,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2013,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2014,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2015,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2016,
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2024,
    "Mo": "Countryman (U25) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2025,
    "Mo": "Countryman (U25) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Equinox EV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Equinox EV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "h",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID.Buzz Cargo (Short Wheel Base) (Short Wheel Base) (4-Türer) Van | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.Buzz Cargo (Short Wheel Base) (Short Wheel Base) (4-Türer) Van | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.Buzz Cargo (Short Wheel Base) (Short Wheel Base) (4-Türer) Van | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID.Buzz People (Short Wheel Base) (Short Wheel Base) (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.Buzz People (Short Wheel Base) (Short Wheel Base) (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.Buzz People (Short Wheel Base) (Short Wheel Base) (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2024,
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2025,
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Territory (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Territory (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2015,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2016,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2017,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q5 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Kicks (P16) (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2019,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2020,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2021,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2022,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2023,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2024,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "01 (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Pilot (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Pilot (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Pilot (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2011,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2018,
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2019,
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2020,
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2021,
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2022,
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500X (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "EHS (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Frontera (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2022,
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2023,
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chery",
    "Y": 2025,
    "Mo": "Tiggo 4 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2020,
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2021,
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2022,
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2023,
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2024,
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Espace (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Espace (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Espace (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2020,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2021,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2022,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2023,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2024,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2025,
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2021,
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2022,
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2023,
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2024,
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Haval",
    "Y": 2025,
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Y": 2022,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Y": 2023,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Y": 2024,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Y": 2025,
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Genesis",
    "Y": 2025,
    "Mo": "GV80 Coupe (5-Türer) SUV | 2025-",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1996,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1997,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1998,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1999,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2000,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2001,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2002,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2003,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2004,
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1998,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 1999,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2000,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2001,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2002,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2003,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2004,
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1990,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1991,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1992,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1993,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1994,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 1999,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2000,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2001,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2002,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2003,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2004,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2005,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2006,
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2009,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2010,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2011,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2012,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2013,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2014,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2015,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2016,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2017,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2018,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2019,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2020,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2021,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2022,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2023,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2024,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2025,
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2012,
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2013,
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2014,
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2015,
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2016,
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2017,
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero (3-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero (3-Türer) SUV | 2005-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Joice (5-Türer) MPV | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Joice (5-Türer) MPV | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Joice (5-Türer) MPV | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2007,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2008,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2009,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2010,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2011,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2012,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2013,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2014,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2015,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2016,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2017,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2018,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2019,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2020,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2021,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2022,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2023,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2024,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2025,
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2004,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2005,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2006,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2007,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2008,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2009,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2010,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2011,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lancia",
    "Y": 2012,
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2006,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2007,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2008,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2009,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2010,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2011,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2012,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2013,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2014,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2015,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2016,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2017,
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2003,
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1983,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1984,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1985,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1986,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1987,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1988,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1989,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1990,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1991,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1992,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1993,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1994,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1995,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1999,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2000,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2001,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2002,
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2018,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2019,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1990,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1991,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1992,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1993,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1994,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1995,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Rasheen (5-Türer) SUV | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Rasheen (5-Türer) SUV | 1999-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1983,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1984,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1985,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1986,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1987,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1988,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1989,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1990,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1991,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1992,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1993,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1994,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1996,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1988,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1989,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1990,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1991,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1992,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1993,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1994,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2001,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2002,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2003,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2004,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2005,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2006,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1997,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1998,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 1999,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2000,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2001,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2002,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2000,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2001,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2010,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2011,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2012,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2013,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2014,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2015,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2016,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2017,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2018,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2019,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2020,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2021,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2022,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2023,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2014,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2015,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2016,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Sealion 7 (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2017,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2018,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2019,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2020,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2021,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2019,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2020,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2021,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2022,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2023,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2024,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2025,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2023,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2024,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Y": 2025,
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2019,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2020,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2021,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2022,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2023,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2024,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2025,
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX1L (U12) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX1L (U12) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX1L (U12) (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2007,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2008,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2023,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAC",
    "Y": 2022,
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2023,
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2024,
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Y": 2025,
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Forester (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2015,
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2016,
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2017,
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2018,
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2019,
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2020,
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2009,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2010,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2011,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2012,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2013,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2014,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2015,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2016,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2017,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2018,
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2009,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2010,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2011,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2012,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2013,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2014,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2015,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2016,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2017,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dodge",
    "Y": 2018,
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Inster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Inster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Zeekr",
    "Y": 2025,
    "Mo": "7X (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Tank 300 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Tank 300 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Tank 300 (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2022,
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2023,
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2024,
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2025,
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2022,
    "Mo": "RX (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2023,
    "Mo": "RX (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2024,
    "Mo": "RX (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Y": 2025,
    "Mo": "RX (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2022,
    "Mo": "9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2023,
    "Mo": "9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2024,
    "Mo": "9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2025,
    "Mo": "9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Lexus",
    "Y": 2024,
    "Mo": "TX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2025,
    "Mo": "TX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2022,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2023,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2024,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2025,
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "4 (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "4 (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "4 (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Capri EV (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "600 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "600 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2018,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2019,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2020,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2021,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2022,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2023,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2024,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daihatsu",
    "Y": 2025,
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2016,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2017,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2018,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2019,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2020,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2021,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Canyon (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Canyon (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Canyon (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "408 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "408 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "408 (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2022,
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2023,
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2024,
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Equinox (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Grandland (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2022,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2023,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2024,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jeep",
    "Y": 2025,
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Prius Prime (XW60) (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Prius Prime (XW60) (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Prius Prime (XW60) (5-Türer) Schrägheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Alfa Romeo",
    "Y": 2025,
    "Mo": "Junior (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2019,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2020,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2021,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2022,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2023,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2024,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Aiways",
    "Y": 2025,
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A5 Sportback (B10) (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "ES5 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "S5 EV (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2023,
    "Mo": "08 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2024,
    "Mo": "08 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lynk & Co",
    "Y": 2025,
    "Mo": "08 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C3 Aircross (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C3 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": "",
    "Mo": "e Vitara (5-Türer) SUV | 2026-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1992,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1993,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1994,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1995,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1996,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1997,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1998,
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1983,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1984,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1985,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1986,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1987,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1988,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1989,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1990,
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1990,
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1991,
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1992,
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1993,
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1994,
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1996,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1997,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2002,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2003,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2004,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2005,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2006,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2007,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2008,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2009,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2010,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2011,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2012,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2013,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2014,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2015,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2016,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2017,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2018,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2019,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2020,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2021,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2022,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2023,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2024,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mahindra",
    "Y": 2025,
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1994,
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1995,
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2003,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2004,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2005,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2006,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2007,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2008,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2009,
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 1996,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 1997,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 1998,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 1999,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2000,
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1984,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1985,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1986,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1987,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1988,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1989,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1990,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1991,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1992,
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2015,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2016,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2017,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2018,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2019,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2020,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2021,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2022,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2012,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2013,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2014,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2015,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2016,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2017,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2018,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2019,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2020,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2021,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2022,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2023,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2024,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2025,
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2000,
    "Mo": "XC70 (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2001,
    "Mo": "XC70 (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2002,
    "Mo": "XC70 (5-Türer) Kombi | 2000-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2003,
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2009,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2010,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2011,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2005,
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2006,
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2007,
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2008,
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2009,
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercury",
    "Y": 2010,
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "RAV 4 (3-Türer) SUV | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV 4 (3-Türer) SUV | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1982,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1983,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1984,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1985,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1986,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1987,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1988,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1989,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1990,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1991,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1992,
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "RAV 4 (5-Türer) SUV | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "RAV 4 (5-Türer) SUV | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2002,
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2003,
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1996,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1997,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1998,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 1999,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2000,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2001,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2001,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2002,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2003,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2004,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2005,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2006,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2007,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2008,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2009,
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1997,
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1998,
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1999,
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2022,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seres",
    "Y": 2024,
    "Mo": "M7 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seres",
    "Y": 2025,
    "Mo": "M7 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2018,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2019,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2020,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2014,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2015,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2016,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2017,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2018,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2019,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2020,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2021,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2022,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2023,
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "EL8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "EL8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2010,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2011,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2012,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2013,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "ZS (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "ZS (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "ES6 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "ES6 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ES6 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2019,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2020,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2021,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2022,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2023,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2024,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2025,
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Seal U (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Seal U (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Doblo (4-Türer) Van | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Doblo (4-Türer) Van | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Doblo (4-Türer) Van | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2007,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "i5 (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "i5 (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2002,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2003,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2004,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2005,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2006,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2007,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2008,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2009,
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2004,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2005,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2006,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Express (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Express (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Express (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Express (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Express (5-Türer) MPV | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Express (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Express (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Express (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Express (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Express (4-Türer) Van | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2011,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2012,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2013,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2014,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2015,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2016,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2017,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2018,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2019,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2020,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2005,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2006,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito (4-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1996,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2022,
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2023,
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2024,
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Rivian",
    "Y": 2025,
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2009,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2010,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2011,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2012,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2013,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2014,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2015,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2016,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Voyah",
    "Y": 2022,
    "Mo": "Free (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Voyah",
    "Y": 2023,
    "Mo": "Free (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Voyah",
    "Y": 2024,
    "Mo": "Free (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Voyah",
    "Y": 2025,
    "Mo": "Free (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2014,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2015,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2016,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2017,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2018,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2019,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2020,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2021,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2022,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2023,
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "ET5 Touring (5-Türer) Kombi | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "ID.Buzz People (Long Wheel Base) (Long Wheel Base) (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.Buzz People (Long Wheel Base) (Long Wheel Base) (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.Buzz People (Long Wheel Base) (Long Wheel Base) (5-Türer) MPV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Touareg (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Touareg (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Y": 2025,
    "Mo": "Actyon (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Trax (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Trax (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Trax (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Zeekr",
    "Y": 2025,
    "Mo": "007GT (5-Türer) Kombi | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "E-5008 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "E-5008 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-50 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-50 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-50 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Elroq (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "5008 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "5008 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2016,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2017,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2018,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2019,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2020,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2021,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2022,
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2024,
    "Mo": "Nautilus (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lincoln",
    "Y": 2025,
    "Mo": "Nautilus (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Macan Electric (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Macan Electric (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2018,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2019,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2020,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2021,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2005,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2006,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2007,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2014,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2015,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2016,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2017,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2018,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2007,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2008,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2009,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2021,
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2022,
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-90 (KK) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-90 (KK) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2018,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2019,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2020,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2021,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2022,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2023,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2024,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Y": 2025,
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2021,
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2022,
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caravelle (T7) (4-Türer) Bus | 2025-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Terramar (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seres",
    "Y": 2024,
    "Mo": "7 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Seres",
    "Y": 2025,
    "Mo": "7 (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2011,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2012,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2013,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Vitara (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2017,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2018,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2019,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2020,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2021,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPeng",
    "Y": 2022,
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPeng",
    "Y": 2023,
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPeng",
    "Y": 2024,
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPeng",
    "Y": 2025,
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2023,
    "Mo": "EL6 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2024,
    "Mo": "EL6 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Y": 2025,
    "Mo": "EL6 (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2021,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2022,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2023,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2024,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Isuzu",
    "Y": 2025,
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2023,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2024,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Lotus",
    "Y": 2025,
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Ioniq 9 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger Raptor (4-Türer) Doppelkabine | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger Raptor (4-Türer) Doppelkabine | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger Raptor (4-Türer) Doppelkabine | 2020-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2011,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2012,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2013,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2014,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2015,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2016,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2017,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2018,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2019,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2020,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jeep",
    "Y": 2021,
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2014,
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2015,
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2016,
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2017,
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2018,
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2021,
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2022,
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2023,
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2024,
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2023,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2024,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Cadillac",
    "Y": 2025,
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2023,
    "Mo": "Ocean (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2024,
    "Mo": "Ocean (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fisker",
    "Y": 2025,
    "Mo": "Ocean (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Vellfire (AH40) (5-Türer) MPV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Vellfire (AH40) (5-Türer) MPV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Vellfire (AH40) (5-Türer) MPV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2019,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2020,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2021,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2022,
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2023,
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2024,
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Land Rover",
    "Y": 2025,
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Y": 2022,
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Y": 2023,
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Y": 2024,
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Y": 2025,
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2019,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2020,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Explorer Electric (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Explorer Electric (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2014,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2015,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2016,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2017,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2018,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2019,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2020,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2021,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2017,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2018,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2019,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2020,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2021,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2022,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2023,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2024,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Porsche",
    "Y": 2025,
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.7 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.7 (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2021,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2022,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2023,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2024,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Y": 2025,
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2016,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2009,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2010,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2011,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2012,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2013,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2014,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Daewoo",
    "Y": 2015,
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2012,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2013,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2014,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2015,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2016,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2017,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2018,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2019,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Isuzu",
    "Y": 2020,
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Kona (SX2) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Kona (SX2) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Kona (SX2) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Grandland (5-Türer) SUV | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Superb (B9) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Superb (B9) (5-Türer) Schrägheck | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Colorado (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Colorado (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Colorado (4-Türer) Pickup | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2022,
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2023,
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2024,
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2025,
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2012,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2013,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2014,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2015,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2016,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2017,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2018,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2019,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2016,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2017,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2018,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2019,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2020,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2021,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2022,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2023,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mini",
    "Y": 2024,
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OMODA",
    "Y": 2022,
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2023,
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2024,
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Y": 2025,
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Smart",
    "Y": 2025,
    "Mo": "#5 (5-Türer) SUV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Maxus",
    "Y": 2024,
    "Mo": "G70 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Maxus",
    "Y": 2025,
    "Mo": "G70 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2018,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2019,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2020,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2021,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2022,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2023,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2024,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Jaguar",
    "Y": 2025,
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Grand Highlander (AS10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Grand Highlander (AS10) (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Tesla",
    "Y": 2015,
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2016,
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2017,
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2018,
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Tesla",
    "Y": 2019,
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "Maxus",
    "Y": 2024,
    "Mo": "MIFA 7 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Maxus",
    "Y": 2025,
    "Mo": "MIFA 7 (5-Türer) MPV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2025,
    "Mo": "Maxus 7 (5-Türer) MPV | 2025-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2025,
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Casper Electric (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Casper Electric (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2022,
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2023,
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2024,
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Y": 2025,
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2013,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Combo (4-Türer) Van | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2019,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2020,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2021,
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "3008 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "3008 (5-Türer) SUV | 2024-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2021,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2022,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2023,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2024,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ora",
    "Y": 2025,
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2022,
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2023,
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2024,
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Peugeot",
    "Y": 2025,
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2019,
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2020,
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2021,
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2016,
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2021,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2022,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2023,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2024,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2014,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2015,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2016,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2017,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2018,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2019,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2020,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2021,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2022,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2022,
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2023,
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2024,
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Honda",
    "Y": 2025,
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2013,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2014,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2015,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2016,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2017,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2018,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2019,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2020,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2021,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2022,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2023,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2024,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volvo",
    "Y": 2025,
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2019,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2020,
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2005,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2006,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2007,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Camry (XV80) (4-Türer) Stufenheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Skoda",
    "Y": 2025,
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2016,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2017,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Audi",
    "Y": 2018,
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "500X (5-Türer) SUV | 2016-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2023,
    "Mo": "C4 X (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2024,
    "Mo": "C4 X (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Citroën",
    "Y": 2025,
    "Mo": "C4 X (4-Türer) Stufenheck | 2023-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1984,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1985,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1986,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1987,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1988,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1989,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1990,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1991,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1992,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1993,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1994,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1995,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1996,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1997,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 1998,
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2016,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2013,
    "Mo": "Clubvan (4-Türer) Van | 2013-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 1999,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2000,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2001,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2002,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2003,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2004,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chrysler",
    "Y": 2005,
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2001,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2002,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2003,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1985,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1986,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1987,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1988,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1989,
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1982,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1983,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1984,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1985,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1986,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1987,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1988,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1989,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1990,
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2004,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2005,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2006,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2007,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2008,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2009,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2010,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2011,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 2012,
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1994,
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1995,
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1996,
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1997,
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2001,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2002,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2003,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2004,
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2016,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2017,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2018,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2005,
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2006,
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2007,
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2007,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2008,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2009,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2010,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2011,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2012,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2013,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2014,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2015,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2016,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2020,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2021,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2022,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2023,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2024,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2025,
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1988,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1989,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1990,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1991,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1992,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1993,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1994,
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2004,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2005,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2006,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2007,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2008,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2009,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2010,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2011,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1992,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1993,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1994,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1995,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2005,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2006,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2007,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2008,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2009,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2010,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2011,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2012,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2013,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2014,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2015,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2016,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2017,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2018,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2019,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2020,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2021,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2022,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2023,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2024,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Y": 2025,
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1990,
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1991,
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1992,
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1993,
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1994,
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1995,
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1996,
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1997,
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1998,
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1991,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1992,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1997,
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1987,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1988,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1989,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1990,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1991,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2008,
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2009,
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2010,
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2011,
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2012,
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2008,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2009,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2010,
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2014,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2015,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2016,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2017,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2018,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2019,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2020,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2021,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2022,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2023,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2024,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Infiniti",
    "Y": 2025,
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1986,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1987,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1988,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1989,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1990,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1991,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1992,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1992,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1993,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1994,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1995,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1996,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 1997,
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2009,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2010,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2011,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Delica Mini (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Delica Mini (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Delica Mini (5-Türer) SUV | 2023-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2017,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2018,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2019,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2020,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2021,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2022,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2023,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2024,
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1990,
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1991,
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1992,
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1993,
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1994,
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2007,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2008,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2009,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 1999,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2000,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2001,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2002,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2003,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2004,
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1997,
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2010,
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2011,
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2012,
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2013,
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2014,
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2015,
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1996,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1997,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1998,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 1999,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2000,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2001,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2002,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2003,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2004,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dodge",
    "Y": 2005,
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2008,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2009,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2010,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2011,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2012,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2013,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2014,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2015,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2016,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2017,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2018,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2019,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2020,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2021,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2022,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2023,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2024,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Jonway",
    "Y": 2025,
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2004,
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2005,
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2006,
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2007,
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2008,
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2009,
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1997,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1998,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 1999,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2000,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2001,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2002,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Daewoo",
    "Y": 2003,
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2014,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2015,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2016,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2017,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2018,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2019,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2020,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2021,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2022,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2023,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2024,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Great Wall",
    "Y": 2025,
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1996,
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1997,
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1998,
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 1999,
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2000,
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1996,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2024,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2025,
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2000,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2001,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2002,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2003,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2004,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2005,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2006,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2007,
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1998,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1999,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2000,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2001,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2002,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2016,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2017,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2018,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2019,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2020,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2021,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2022,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2023,
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2008,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2009,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2010,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2011,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2012,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2013,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2014,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2015,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2016,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2017,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Peugeot",
    "Y": 2018,
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1998,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 1999,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2000,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1991,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1992,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1993,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1994,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1995,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1996,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2001,
    "Mo": "Life (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2002,
    "Mo": "Life (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Life (5-Türer) Kombi | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2011,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2012,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2013,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2014,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2015,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2016,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2017,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2018,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2019,
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2001,
    "Mo": "Ipsum (5-Türer) MPV | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Ipsum (5-Türer) MPV | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Ipsum (5-Türer) MPV | 2001-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1993,
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1994,
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1995,
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volvo",
    "Y": 1996,
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1990,
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1991,
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1992,
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1993,
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 1994,
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2011,
    "Mo": "9-4X (5-Türer) SUV | 2011-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2012,
    "Mo": "9-4X (5-Türer) SUV | 2011-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1996,
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1997,
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1998,
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 1999,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2000,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2001,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2002,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2003,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2004,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2005,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2006,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2007,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2018,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2019,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2020,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2021,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2022,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2023,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2024,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2025,
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2003,
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2004,
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1998,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 1999,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2008,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2009,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2010,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2011,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2012,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2013,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mini",
    "Y": 2014,
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2002,
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2003,
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2004,
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2005,
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2006,
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2003,
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2004,
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2005,
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2006,
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2007,
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2008,
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1998,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 1999,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2000,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2001,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2002,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2003,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2004,
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2002,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2003,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2004,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2005,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 1999,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2000,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2001,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2002,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2003,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2004,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2005,
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2004,
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2005,
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2006,
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Dingo (5-Türer) MPV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Dingo (5-Türer) MPV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Dingo (5-Türer) MPV | 1999-2001",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2004,
    "Mo": "RX (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2005,
    "Mo": "RX (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lexus",
    "Y": 2006,
    "Mo": "RX (5-Türer) SUV | 2004-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2008,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2017,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2018,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2019,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2020,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2021,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2022,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2023,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2024,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2025,
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2009,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2010,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2011,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Dacia",
    "Y": 2025,
    "Mo": "Bigster (5-Türer) SUV | 2025-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2005,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2006,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2007,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2008,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2009,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2010,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2011,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Saab",
    "Y": 2012,
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2017,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2018,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2002,
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2003,
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2004,
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2005,
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2004,
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2005,
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2006,
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1997,
    "Mo": "MPV (5-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1998,
    "Mo": "MPV (5-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1999,
    "Mo": "MPV (5-Türer) MPV | 1997-1999",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2000,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2001,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2002,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2003,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2004,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2005,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2006,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2007,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2008,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2009,
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2010,
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2011,
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2012,
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2013,
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2014,
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2015,
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1992,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1993,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1994,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1995,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1996,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1997,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1998,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 1999,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2000,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2013,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2014,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2015,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2020,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2021,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2022,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2023,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2024,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2025,
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2004,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2005,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2006,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2007,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2008,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2009,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2010,
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2007,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2008,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2007,
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1992,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1993,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1994,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1995,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1996,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1997,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 1998,
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1996,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1997,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1998,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 1999,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2000,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2001,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2002,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2003,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2004,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2005,
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 1999,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2000,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2001,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2002,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2003,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2004,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2005,
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2013,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2014,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2015,
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2003,
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2004,
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2005,
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2006,
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2007,
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2008,
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2012,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2013,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2014,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2015,
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2015,
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2016,
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2017,
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2018,
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Y": 2019,
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2024,
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2009,
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2010,
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2011,
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2012,
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2013,
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2012,
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2013,
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2014,
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2006,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2007,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2008,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2009,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2010,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2011,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2012,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2013,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2014,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2015,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2016,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2017,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2018,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2019,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2020,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2021,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2022,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2023,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2024,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Holden",
    "Y": 2025,
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1997,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1998,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2004,
    "Mo": "Streetwise (5-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Rover",
    "Y": 2005,
    "Mo": "Streetwise (5-Türer) Schrägheck | 2004-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1996,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2012,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2004,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2005,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2006,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2007,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2018,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2019,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2020,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2021,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2022,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2023,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2024,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2025,
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2009,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2010,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2011,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2012,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2013,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2014,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2015,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2016,
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1997,
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1998,
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 1999,
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2000,
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2011,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2012,
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1993,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1994,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1995,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1996,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1997,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1998,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 1999,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2000,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2001,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2002,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2003,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2004,
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2005,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2006,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2007,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2008,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2009,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2006,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2007,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2008,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2009,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2010,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2011,
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2001,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2002,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2003,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2004,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2005,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2006,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2007,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2008,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2009,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2010,
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1991,
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1992,
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1993,
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1994,
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1995,
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 1996,
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2008,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2009,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2010,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2011,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2012,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1997,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1998,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 1999,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2000,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2001,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2002,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2003,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2004,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1988,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1989,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1990,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1991,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1992,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1993,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1994,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1995,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1996,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 1997,
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2006,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2007,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2008,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2009,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2010,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2011,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2012,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2013,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2014,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2015,
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2007,
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2008,
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2009,
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2010,
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Hyundai",
    "Y": 2011,
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2008,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2009,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2010,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2011,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2012,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2013,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2014,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2015,
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2020,
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2021,
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2022,
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2023,
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2024,
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mazda",
    "Y": 2025,
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1995,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1996,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1997,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1998,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 1999,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2000,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2001,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2002,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2003,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2004,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2005,
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 1999,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2000,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2001,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2002,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2003,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2004,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2005,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mitsubishi",
    "Y": 2006,
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2006,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2007,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2019,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2020,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2021,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2022,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2023,
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2016,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2017,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2018,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2019,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2020,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2021,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2022,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2023,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2024,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Seat",
    "Y": 2025,
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2007,
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2008,
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2009,
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2010,
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2011,
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Citroën",
    "Y": 2012,
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2021,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2022,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2023,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2009,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2010,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2011,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2012,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2013,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2014,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Skoda",
    "Y": 2015,
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2016,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2017,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2018,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2019,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2020,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2021,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2022,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2023,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2024,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Ssangyong",
    "Y": 2025,
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2005,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2006,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1998,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 1999,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2000,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2001,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2002,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2003,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2004,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2005,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2006,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2007,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2008,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2009,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2010,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2011,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2012,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2013,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2014,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2015,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2016,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2017,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2018,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2019,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2020,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2021,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2022,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2023,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2024,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Lada",
    "Y": 2025,
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2017,
    "Mo": "Karl rocks (5-Türer) Schrägheck | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2018,
    "Mo": "Karl rocks (5-Türer) Schrägheck | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Opel",
    "Y": 2019,
    "Mo": "Karl rocks (5-Türer) Schrägheck | 2017-2019",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2008,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2009,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2010,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2011,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2012,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2013,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2014,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2015,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2016,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Fiat",
    "Y": 2017,
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2013,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2014,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2015,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2016,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2017,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Subaru",
    "Y": 2018,
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2016,
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2017,
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2018,
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Ford",
    "Y": 2019,
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2019,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2020,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2021,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2022,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2023,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2024,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Kia",
    "Y": 2025,
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2008,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2009,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2010,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2011,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2012,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2013,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2014,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2015,
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2022,
    "Mo": "iX (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2023,
    "Mo": "iX (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "iX (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "iX (5-Türer) SUV | 2022-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2012,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2013,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2014,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2015,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2016,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2017,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Honda",
    "Y": 2018,
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2007,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2008,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2009,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2010,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2011,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2021,
    "Mo": "Across (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2022,
    "Mo": "Across (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2023,
    "Mo": "Across (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2024,
    "Mo": "Across (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Suzuki",
    "Y": 2025,
    "Mo": "Across (5-Türer) SUV | 2021-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2008,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2009,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2010,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2011,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2012,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2013,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2014,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2015,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2016,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Vauxhall",
    "Y": 2017,
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2017,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2018,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2019,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2020,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2021,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2022,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2023,
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2012,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2013,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2014,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2015,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2016,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2017,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2018,
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2024,
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Acura",
    "Y": 2025,
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2024,
    "Mo": "Blazer EV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Chevrolet",
    "Y": 2025,
    "Mo": "Blazer EV (5-Türer) SUV | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2019,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2024,
    "Mo": "5-Series (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Y": 2025,
    "Mo": "5-Series (G60) (4-Türer) Stufenheck | 2024-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2016,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2017,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2018,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2019,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2020,
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2021,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2022,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2023,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2024,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2015,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2016,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2017,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2018,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2019,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2020,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2021,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2022,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2023,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2010,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2011,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2012,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2013,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2014,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2015,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2016,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2017,
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2018,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2019,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2020,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Toyota",
    "Y": 2019,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2020,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2021,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2022,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2023,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2024,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Toyota",
    "Y": 2025,
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Audi",
    "Y": 2025,
    "Mo": "A6 Sportback e-tron (5-Türer) Schrägheck | 2025-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2024,
    "Mo": "ID.7 Tourer (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "Volkswagen",
    "Y": 2025,
    "Mo": "ID.7 Tourer (5-Türer) Kombi | 2024-",
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2017,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2018,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2019,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2020,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2021,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2022,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2023,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2024,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Y": 2025,
    "Mo": "TGE (4-Türer) Van | 2017-",
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "Nissan",
    "Y": 2021,
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2022,
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2023,
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2024,
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Nissan",
    "Y": 2025,
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "Renault",
    "Y": 2024,
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Renault",
    "Y": 2025,
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2020,
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2021,
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2022,
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2023,
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2024,
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "Mercedes-Benz",
    "Y": 2025,
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "c": "a",
    "T": "Yes"
  }
]